import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { BsTelephoneFill, BsEnvelopeFill, BsGeoAltFill } from "react-icons/bs"; // ✅ Corrected imports
import axios from "axios";
import Axios from "../../services/AxiosInterceptor";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
      });


      const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await Axios.post("api/send-enquiry", formData);
      setStatus(response.data.message);
      setFormData({ name: "", email: "", message: "" }); // Clear form on success
    } catch (error) {
      setStatus("Error sending enquiry. Please try again.");
    }
  };

  return (
    <Container className="py-5">
      <h2 className="text-center fw-bold mb-4">📞 Contact Us</h2>
      <p className="text-center text-muted mb-4">
        Feel free to reach out to us for any inquiries or assistance.
      </p>

      <Row className="g-4">
        {/* Contact Info */}
        <Col lg={6}>
          <Card className="shadow border-0 p-4">
            <Card.Body>
              <h4 className="fw-bold">Ajay Nama</h4>
              <p className="text-muted">Owner</p>
              <p>
                <BsTelephoneFill className="text-primary me-2" /> 
                <strong>Mobile:</strong> <a href="tel:+919782728996"> +91 9828381188</a>
              </p>
              <p>
                <BsEnvelopeFill className="text-danger me-2" /> 
                <strong>Email:</strong> <a href="mailto:ajay@gmail.com">yogawithajaynama@gmail.com</a>
              </p>
              <p>
                <BsGeoAltFill className="text-success me-2" /> 
                <strong>Head Office:</strong> Yogamatic, Mahaveer nagar Y, 80 ft road sanganer, Jaipur 302029
              </p>
              <p>
                <BsGeoAltFill className="text-success me-2" /> 
                <strong>Branch Office:</strong>Yogamatic, 80 Feet Rd, behind chouradiya petrol pump, near adarsh vidya mandir school, Ramdara Colony, Mahaveer Nagar Y, Dada Gurudev Nagar, Sanganer, Jaipur, Rajasthan 302029
              </p>
              
            </Card.Body>
          </Card>
        </Col>

        {/* Contact Form */}
    
        <Col lg={6}>
          <Card className="shadow border-0 p-4">
            <Card.Body>
              <h4 className="fw-bold mb-3">Send Us a Message</h4>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control as="textarea" rows={4} name="message" value={formData.message} onChange={handleChange} placeholder="Your Message" required />
                </Form.Group>
                <Button style={{background:"#DBA400",border:"none"}} type="submit" className="w-100">
                  Send Message
                </Button>
              </Form>
              {status && <p className="mt-3 text-center">{status}</p>}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Google Map Embed */}
      <Row className="mt-5">
        <Col>
          <h4 className="text-center fw-bold">📍 Our Location</h4>
          <div className="ratio ratio-16x9 mt-3">
          <iframe
  title="Yogamatic Location"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.3001182487965!2d75.77143477479191!3d26.811093576677734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db53b8e75e7cf%3A0x365b2e5b9d853c71!2sYogamatic%2C%20Mahaveer%20Nagar%20Y%2C%2080%20Ft%20Road%2C%20Sanganer%2C%20Jaipur%2C%20Rajasthan%20302029!5e0!3m2!1sen!2sin!4v1711400000000"
  width="100%"
  height="200px"
  style={{ border: 0 }} // ✅ Fixed JSX Syntax
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>


          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;


